import React from "react";
import "./EmptyScreen.scss";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const EmptyScreen = ({
  img,
  loader = false,
  text,
  title,
  desc,
  desc2 = "",
  small = false,
  showButton = false,
  BtnTitle = "",
  BtnTitleId="",
  BtnIcon,
  BtnCTA,
  titleName="",
  descName=""
}) => {
  // pass small as true to get smaller UI
  return (
    <div className={`NoResultWrapper ${small ? "small" : ""}`}>
      {loader && text ? (
        <CircularProgressbar
          value={text}
          text={`${text}%`}
          styles={buildStyles({ pathTransition: "none" })}
          className="progress-loader"
        />
      ) : (
        <div className={`imageContainer ${small ? "small" : ""}`}>
          <div className={`outerRing ${small ? "small" : ""}`}>
            <div className={`innerRing ${small ? "small" : ""}`}>
              <div className={`img ${small ? "small" : ""}`}>{img}</div>
            </div>
          </div>
        </div>
      )}

      <div
        className={`title ${small ? "small" : ""}`}
        id="emptyScreenTitle"
        name={titleName.length ? `${titleName}_title` : ""}
      >
        {title}
      </div>
      <div
        className={`desc ${small ? "small text-6" : "text-5"} ${loader ? "desc1" : ""}`}
        id="emptyScreenDescription"
        name={descName.length ? `${descName}_description` : ""}
      >
        {desc}
      </div>
      <div
        className={`desc desc2 ${small ? "small text-6" : "text-5"}`}
        id="emptyScreenDescription"
      >
        {desc2}
      </div>
      {showButton && (
        <button
          id={BtnTitleId}
          type="button"
          className="roundBtn primary"
          onClick={BtnCTA}
        >
          {BtnIcon}
          <span>{BtnTitle}</span>
        </button>
      )}
    </div>
  );
};

export default EmptyScreen;
